import React from 'react';
import i18n from 'util/i18n';
import Spinner, { SpinnerAction } from 'components/Form/Spinner';

interface Props {
  show?: boolean
}

const Loading: React.FC<Props> = ({ show }) => (
  <Spinner
    className="loading-modal"
    show={show}
    action={SpinnerAction.Spin}
    label={i18n.m('application.loading.title')}
  />
);

export default Loading;
